import { Box, Grid, MenuItem, TextField } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import type { ILegalClientFullObject } from '../Interfaces/ILegalClient';
import type { State } from '../redux/mainReducer';

type IProps = {
  formValues: ILegalClientFullObject;
  setFormValues: Dispatch<SetStateAction<ILegalClientFullObject>>;
};

export const LegalPersonForm = ({ formValues, setFormValues }: IProps) => {
  const contactGroups = useSelector(
    (state: State) => state.contactGroup.storeContactGroup
  );

  const businessForms = useSelector(
    (state: State) => state.businessFormArray.storeBusinessForm
  );

  return (
    <>
      <Grid item xs={3}>
        <TextField
          select
          label='Gruppe'
          size='small'
          fullWidth
          value={formValues.idContactGroup || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const contactGroupId = Number(event.target.value);

            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              idContactGroup: contactGroupId,
              ContactGroup: contactGroups.find(
                contactGroup => contactGroup.idContactGroup === contactGroupId
              )?.ContactGroup,
            }));
          }}
        >
          <MenuItem key={`idContactGroup-null}`} value={-1}>
            <i>Keine Gruppe zugeordnet</i>
          </MenuItem>
          {contactGroups.map((cg, i) => (
            <MenuItem key={i} value={cg.idContactGroup}>
              {cg.ContactGroup}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={6} />

      <Grid item xs={3}>
        <TextField
          select
          label='Rechtsform'
          size='small'
          fullWidth
          value={formValues.idBusinessForm || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const businessFormId = Number(event.target.value);

            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              idBusinessForm: businessFormId,
              BusinessForm: businessForms.find(
                businessForm => businessForm.idBusinessForm === businessFormId
              )?.BusinessForm,
            }));
          }}
        >
          <MenuItem key={`idBusinessForm-null}`} value={-1}>
            <i>Keine Rechtsform zugeordnet</i>
          </MenuItem>
          {businessForms.map((bf, i) => (
            <MenuItem key={i} value={bf.idBusinessForm}>
              {bf.BusinessForm}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={9}>
        <TextField
          required
          label='Firmenname'
          value={formValues.LastName || ''}
          size='small'
          fullWidth
          onChange={event => {
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              LastName: event.target.value,
            }));
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ mt: 0.5 }} />
      </Grid>

      <Grid item xs={6}>
        <TextField
          InputLabelProps={{ shrink: true }}
          label='Gründungsdatum'
          size='small'
          value={formValues.Birthdate || ''}
          fullWidth
          type='date'
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              Birthdate: event.target.value,
            }))
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label='Gründungsort'
          size='small'
          value={formValues.Birthplace || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              Birthplace: event.target.value,
            }))
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          InputLabelProps={{ shrink: true }}
          label='Auflösungsdatum'
          size='small'
          value={formValues.DateOfDeath || ''}
          fullWidth
          type='date'
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              DateOfDeath: event.target.value,
            }))
          }
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label='Auflösungsort'
          size='small'
          value={formValues.PlaceOfDeath || ''}
          fullWidth
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              PlaceOfDeath: event.target.value,
            }))
          }
        />
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ mt: 0.5 }} />
      </Grid>

      <Grid item xs={3}>
        <TextField
          label='Steuernummer'
          size='small'
          value={formValues.TaxNumber || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              TaxNumber: event.target.value,
            }))
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label='Umsatzsteuer-ID'
          size='small'
          value={formValues.SalesTaxNumber || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              SalesTaxNumber: event.target.value,
            }))
          }
          fullWidth
        />
      </Grid>
      {/*
      <Grid item xs={3}>
        <TextField
          label='E-Mail-Adresse'
          size='small'
          type='email'
          value={formValues.Email}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setFormValues((prev: ILegalClientFullObject) => ({
              ...prev,
              Email: event.target.value,
            }))
          }
          fullWidth
          required
        />
      </Grid>
       */}

      <Grid
        item
        xs={3}
        display='flex'
        justifyContent='center'
        alignItems='center'
      >
        {formValues.idArnoTopIntern && (
          <Box>
            <strong>Namen.Nr.:</strong> {formValues.idArnoTopIntern}
          </Box>
        )}
      </Grid>
    </>
  );
};
